export default {
  creatingUser: 'Creating user {name}...',
  title: 'Users',
  createUser: 'Create User',
  warningTitle: 'Warning',
  deleteConfirmation: 'Deleting user: {name}',
  deleteWarning: 'This action cannot be undone. Are you sure?',
  cancel: 'Cancel',
  delete: 'Delete',
  editUser: 'Edit User',
  deleteUser: 'Delete User',
  deleting: 'Deleting...',
  headerFirstName: 'First name',
  headerLastName: 'Last name',
  headerEmail: 'Email',
  headerAdmin: 'Admin',
  headerManager: 'Manager',
  headerScientist: 'Scientist',
  headerSupervisor: 'Supervisor',
  headerCustomizer: 'Customizer',
  headerDomain: 'Domain',
  headerCreated: 'Created',
  headerActions: 'Actions'
}
